module.exports = __webpack_public_path__ + "static/img/wx.10de4e91.png";